import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { FeedbackItem, formatFeedbackDate } from '@/types/residents/marketplaceListing';
import { StarRating } from './StarRating';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const PropertyPlaceholder = RESIDENTS_SVG_COMPONENTS.PROPERTY_PLACEHOLDER;

interface FeedbackCardProps {
  feedback: FeedbackItem;
  showDivider?: boolean;
}

export const FeedbackCard: React.FC<FeedbackCardProps> = ({
  feedback,
  showDivider = true,
}) => {
  console.log('feedback', feedback);
  return (
    <View style={styles.container}>
      {/* Product Image */}
      {feedback.itemImageUrl ? (
        <Image
          source={{ uri: feedback.itemImageUrl }}
          style={styles.productImage}
          resizeMode="cover"
        />
      ) : (
        <View style={[styles.productImage, styles.productImagePlaceholder]}>
          <PropertyPlaceholder width={24} height={24} />
        </View>
      )}

      {/* Content */}
      <View style={[styles.content, showDivider && styles.contentWithDivider]}>
        {/* Top Row - Stars and Date */}
        <View style={styles.topRow}>
          <StarRating rating={feedback.rating} size={16} />
          <Text style={styles.date}>{formatFeedbackDate(feedback.date)}</Text>
        </View>

        {/* Item Title */}
        <Text style={styles.itemTitle} numberOfLines={2}>
          {feedback.itemTitle}
        </Text>

        {/* Review Text (optional) */}
        {feedback.reviewText && (
          <Text style={styles.reviewText}>
            {feedback.reviewText}
          </Text>
        )}

        {/* Buyer Name */}
        <Text style={styles.buyerName}>
          {feedback.reviewerName}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 16,
    paddingVertical: 10,
  },
  productImage: {
    width: 46,
    height: 46,
    borderRadius: 23,
    borderWidth: 0.45,
    borderColor: MARKETPLACE_COLORS.borderGray,
  },
  productImagePlaceholder: {
    backgroundColor: MARKETPLACE_COLORS.uploadAreaBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    flex: 1,
    gap: 4,
    paddingBottom: 16,
  },
  contentWithDivider: {
    borderBottomWidth: 1,
    borderBottomColor: MARKETPLACE_COLORS.dividerGray,
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  date: {
    fontSize: 12,
    fontWeight: '300',
    color: MARKETPLACE_COLORS.textMuted,
    lineHeight: 18,
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  reviewText: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.gray200,
    lineHeight: 21,
  },
  buyerName: {
    fontSize: 12,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textMuted,
    lineHeight: 18,
  },
});

